

































import {
  Vue, Prop, Component,
} from 'vue-property-decorator';
import LogComponent from '@/shared/log/log.component.vue';
import toCurrency from '@/shared/directive/toCurrency';
import { BillingStatusItemType } from '@/shared/utils/billing-status-item-type.enum';
import BillingItem from './billing-item.entity';

@Component({
  components: {
    LogComponent,
  },
  filters: {
    toCurrency,
  },
})
export default class BillingItemsExpansion extends Vue {
  @Prop({
    required: true,
  })
  billingItems!: Array<BillingItem>;

  currencyFormat: any = toCurrency;

  showTotal: boolean = false;

  getStatusColor(status: string): string {
    switch (status) {
      case BillingStatusItemType.VALID:
        return 'teal';
      case BillingStatusItemType.INVALID:
        return 'error';
      default:
        return '';
    }
  }

  getStatusIcon(status: string): string {
    switch (status) {
      case BillingStatusItemType.LOADING:
        return 'mdi-progress-clock';
      case BillingStatusItemType.VALID:
        return 'mdi-check';
      case BillingStatusItemType.INVALID:
        return 'mdi-alert-circle';
      default:
        return '';
    }
  }
}
